import styled from 'styled-components';
import { CardPage, Tag, TAX_ROUND_OFF, CurrencyText } from '@nile/components';
import React from 'react';
import { roundToFixed } from '@nile/components/src/Utils/helpers';
import { find, has, isEmpty, isEqual, reduce, size, sortBy } from 'lodash';

const Wrapper = styled(CardPage)`
  .Superops-TextField__ActionableSuffix {
    background: ${(props) =>
      props.clicked ? '#fffae4' : 'rgba(0, 0, 0, 0.05)'};
    border-radius: 10px 10px 0 0;
    transition: background 200ms linear;
  }
  .colHeader {
    padding-left: 8px;
  }
  .Superops-TextField__Input {
    border-bottom: 1px solid #ececec;
  }
  .Superops-Connected {
    padding-top: 0 !important;
  }
  .Superops-TextField__Input {
    min-height: 38px;
  }
  .Superops-TextField__Input {
    padding-left: 4px;
  }
  .red {
    color: red;
  }
  .sk-table-container {
    height: 400px !important;
  }
`;

const DateSection = styled.div`
  .react-datepicker-wrapper,
  .react-datepicker__input-container > input {
    width: 170px;
  }
`;

const Row = styled.div`
  line-height: 35px;
  font-weight: 500;
  width: ${(props) => props.width};
`;

const getSubTotal = (d, data) => {
  let sTotal = 0;
  const items = data.items || [];
  items.forEach((el) => {
    sTotal += Number(el.amount);
  });
  return sTotal;
};
const getTaxes = (d, data) => {
  let totalTax = 0;
  const ROUND_OFF_LIMIT = 2;
  // change the taxAmount in tax group by calculating tax for each line item.
  if (data.taxes) {
    data.taxes.forEach((tax, idx) => {
      let taxAmount = 0;
      data.items.forEach((item) => {
        if (
          item.tax &&
          item.tax.rates.some((r) => r.rateId === tax?.rate?.rateId) &&
          item.taxable
        ) {
          const taxRateValue = Number(tax.taxRate) / 100;
          const lineItemTaxAmount = Number(item.amount) * taxRateValue;
          taxAmount += roundToFixed(lineItemTaxAmount, ROUND_OFF_LIMIT);
        }
      });
      totalTax += taxAmount;
    });
  }
  return totalTax;
};
// Calculate additional discount based on discountRate
const getAdditionalDiscount = (sTotal, tRates, data) => {
  let additionalDiscount = 0;
  if (data.additionalDiscount) {
    additionalDiscount = data.additionalDiscount;
  } else if (data.additionalDiscountRate) {
    additionalDiscount =
      ((sTotal + tRates) * Number(data.additionalDiscountRate)) / 100;
  }
  additionalDiscount = Number(parseFloat(additionalDiscount).toFixed(2));
  return additionalDiscount;
};

const getPrefix = (el) => {
  switch (el.type) {
    case 'Tag':
      return (
        <div className="flex jend mr10">
          <Tag>{el.prefix}</Tag>
        </div>
      );
    default:
      return <>{el.prefix}</>;
  }
};

const getValue = (el, countryCode, currencyCode) => {
  switch (el.name) {
    case 'addAdditionalDiscount':
      return '';
    default:
      return <CurrencyText value={el.value} />;
  }
};

export function getTaxLabel({ taxName, rateName }) {
  if (taxName?.trim() === rateName?.trim()) {
    return taxName ?? '';
  }

  return `${taxName} - ${rateName}`;
}

export function sortItems(items) {
  if (!items) return [];
  return sortBy(items, 'itemOrder');
}

export function getDragHandleColumnProps({ data, clientId, editMode = true }) {
  return {
    Header: ' ',
    accessor: 'name',
    width: editMode ? 50 : 5,
    type: 'Drag',
    id: 'dragHandle',
    className: 'sticky',
    disableSortBy: true,
    editable: false,
    disableFilters: true,
    actions: {
      onChange: () => {}
    },
    field: null,
    isBold: false,
    editMode,
    clientId: clientId,
    allData: data || {},
    disableResizing: true
  };
}

export function reorderItems({ newOrderItems }) {
  return newOrderItems.map((item, index) => {
    return {
      ...item,
      itemOrder: index + 1
    };
  });
}

export function findItemOrderDiff(baseArray, modifiedArray) {
  let dataModified = false;
  const res = reduce(
    modifiedArray,
    (result, modifiedItem) => {
      const baseItem = find(baseArray, { itemId: modifiedItem.itemId });

      if (baseItem) {
        const diff = reduce(
          modifiedItem,
          (changes, value, key) => {
            if (!isEqual(value, baseItem[key])) {
              // eslint-disable-next-line no-param-reassign
              changes[key] = value;
            }
            return changes;
          },
          {}
        );

        if (!isEmpty(diff) && size(diff) === 1 && has(diff, 'itemOrder')) {
          result.push({ itemId: modifiedItem.itemId, ...diff });
        } else {
          dataModified = true;
        }
      }

      return result;
    },
    []
  );

  return { result: res, dataModified };
}

export {
  Row,
  DateSection,
  Wrapper,
  getSubTotal,
  getTaxes,
  getAdditionalDiscount,
  getPrefix,
  getValue
};
